import { ComponentType, memo } from 'react';

import { SliderHelpers } from '../..';
import { SlideGridContainer, SliderChunk } from '../SlideGridContainer';

import { ScSlider } from './styled';

interface ISlider<T> {
  currentSlideIndex: number;
  handleNativeScroll: (event: React.UIEvent<HTMLDivElement>) => void;
  slidesPerView?: number;
  sliderRef: React.RefObject<HTMLDivElement>;
  slidesChunk?: SliderChunk<T>[];
  itemComponent: ComponentType<T>;
  sliderHelpers: SliderHelpers;
}

export const SliderComponent = <T,>({
  sliderRef,
  currentSlideIndex,
  handleNativeScroll,
  slidesPerView,
  slidesChunk,
  itemComponent,
  sliderHelpers,
}: ISlider<T>) => {
  return (
    <ScSlider
      ref={sliderRef}
      onScroll={handleNativeScroll}
      slidesPerView={slidesPerView}
    >
      {slidesChunk?.map((slideProps, index) => (
        <div
          key={index}
          className={`snap-item${index === currentSlideIndex ? ' current-slide' : ''}`}
        >
          <SlideGridContainer
            {...slideProps}
            key={index}
            sliderHelpers={sliderHelpers}
            itemComponent={itemComponent}
          />
        </div>
      ))}
    </ScSlider>
  );
};

export const Slider = memo(SliderComponent) as typeof SliderComponent;
